import { createAction } from 'redux-actions'
import { Dispatch } from 'react'
import { fetchTimeLine, fetchGetTravelInfo, fetchGetCompensateReasonList, fetchCloseOrder, fetchGetOpenTicketByOrder, fetchGetImHistory, fetchGetCallHistory, fetchGetBusStationInfo, fetchQueryPrivacyRights, fetchShowToolBox } from "@/api/service/order";
export const initStateData = {
    status: 0,
    tableFetching: true
}
export const resetState = createAction('RESET_ALLPROMOTION_STATE', () => (initStateData))
export const resetFetchState = createAction('RESET_ALLPROMOTION_FETCH_STATE')

/*  
 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=477292235
*/

// 获取基本信息与订单时间线
export const orderTimeLineSuccess = createAction('ORDER_TIMELINE')
export const orderTimeLine = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchTimeLine(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(orderTimeLineSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 查询拼友信息
export const getTravelInfoSuccess = createAction('GET_TRAVELINFO')
export const getTravelInfo = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchGetTravelInfo(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getTravelInfoSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取补偿原因
export const getCompensateReasonListSuccess = createAction('GET_COMPENSATEREASONLIST')
export const getCompensateReasonList = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchGetCompensateReasonList(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getCompensateReasonListSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取用户权限
export const closeOrderSuccess = createAction('CLOSE_ORDER')
export const closeOrder = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchCloseOrder(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(closeOrderSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 订单查工单
export const getOpenTicketByOrderSuccess = createAction('GET_OPENTICKETBYORDER')
export const getOpenTicketByOrder = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchGetOpenTicketByOrder(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getOpenTicketByOrderSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// IM信息
export const getImHistorySuccess = createAction('GET_IMHISTORY')
export const getImHistory = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchGetImHistory(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getImHistorySuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 订单查工单
export const getCallHistorySuccess = createAction('GET_CALLHISTORY')
export const getCallHistory = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
        return fetchGetCallHistory(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getCallHistorySuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 订单信息模块
export const getBusStationInfoSuccess = createAction('GET_BUS_STATION_INFO')
export const getBusStationInfo = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
      return   fetchGetBusStationInfo(params)
            .then((res) => res.data)
            .then((json) => {
              console.log(json);
                dispatch(getBusStationInfoSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 查询是否展示隐私信息
export  const queryPrivacyRightsSuccess = createAction('QUERY_PRIVACY_RIGHTS')
export const queryPrivacyRights = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
      return   fetchQueryPrivacyRights(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(queryPrivacyRightsSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 查询是否展示隐私信息
export  const showToolBoxSuccess = createAction('SHOW_TOOL_BOX')
export const showToolBox = function (params = {}) {
    return (dispatch: Dispatch<any>) => {
      return   fetchShowToolBox(params)
            .then((res) => res.data)
            .then((json) => {
                dispatch(showToolBoxSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};